'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryAbove } from '@svenskaspelab/ui/media-query/react';
import { Button } from '@svenskaspelab/ui/react/button';
import {} from 'react';
import ModalLink from './ModalLink.js';
/**
 * Component that uses mediaquery to determine which searchparam to apply.
 *
 * @param root0 input props
 * @param root0.children the children to pass down
 * @param root0.queryOnLargeScreen the query if screen is large
 * @param root0.queryOnSmallScreen the query if screen is small
 * @param root0.trackingAction the tracking action to track when the button is clicked
 * @returns Component that uses mediaquery to determine which searchparam to apply
 */
export default function OpenModalButton({ children, queryOnLargeScreen, queryOnSmallScreen, trackingAction, }) {
    const isLargeScreen = useMediaQueryAbove('md');
    const query = isLargeScreen ? queryOnLargeScreen : queryOnSmallScreen;
    return (_jsx(Button, { className: isLargeScreen ? undefined : 'w-full', variant: isLargeScreen ? 'outline' : 'ghost', size: isLargeScreen ? 'md' : 'sm', render: _jsx(ModalLink, { href: { query }, scroll: false, queriesToKeep: "ALL", onClick: trackingAction }), children: children }));
}
//# sourceMappingURL=OpenModalButton.js.map